export const assetsConst = {
  Logo: "assets/images/mega-store-logo.svg",
  coloredLogo: "assets/images/mega-store-logo-colored.svg",
  homeBanner: "assets/images/home_banner.jpg",
  productAttachment1: "assets/images/product_attachment1.jpg",
  productAttachment2: "assets/images/product_attachment2.jpg",
  productAttachment3: "assets/images/product_attachment3.jpg",

  sentImage: "assets/images/sent.png",
  downloadAttachment: "assets/images/download_attachment.png",
  appStoreIcon: "assets/images/app_store_icon.png",
  playStoreIcon: "assets/images/play_store_icon.png",
  payementIcon: "assets/images/payment_icon.png",
  placeholderImage: "assets/images/placeholder_img.svg",
  paymentVector: "assets/images/payment_vector.svg",
  searchIcon: "assets/images/search_icon.svg",
  locationIcon: "assets/images/location_icon.svg",
  userIcon: "assets/images/user_icon.svg",
  heartIcon: "assets/images/heart_icon.svg",
  heartfilledIcon: "assets/images/heartFiled_icon.svg",
  bagIcon: "assets/images/bag_icon.svg",
  pickUpIcon: "assets/images/ic_house_marker.png",
  destinationIcon: "assets/images/ic_warehouse_marker.png",
  driverIcon: "assets/images/ic_driver_marker.png",
  phoneImage: "assets/images/phone.png",
  facebookIcon: "assets/images/facebook_icon.svg",
  instagramIcon: "assets/images/instagram_icon.svg",
  twitterIcon: "assets/images/twitter_icon.svg",
  backIcon: "assets/images/arrow-left.svg",
  boxIcon: "assets/images/box_icon.svg",
  visaIcon: "assets/images/visa_icon.jpg",
  trashIcon: "assets/images/trash_icon.svg",
  circleTickIcon: "assets/images/circleTick_icon.svg",
  promoIcon: "assets/images/promo_icon.svg",
  cameraIcon: "assets/images/camera_icon.svg",
  directionIcon: "assets/images/direction_icon.svg",
  documentIcon: "assets/images/document_icon.svg",
  cubeIcon: "assets/images/cube_icon.svg",
  deliveryIcon: "assets/images/delivery_icon.svg",
  LocationIcon: "assets/images/location.svg",
  DeleteIcon: "assets/images/delete.svg",
  shareIcon: "assets/images/share_icon.svg",
  wishListIcon: "assets/images/wishlist.png",
  categoryIcon: "assets/images/no-catItem.png",
  noItemInbagIcon: "assets/images/ic_no_product_found.png",
  lacosteIcon: "assets/images/lacoste.png",
  mangoIcon: "assets/images/mango.png",
  homeIcon: "assets/images/home_icon.svg",
  orderIcon: "assets/images/order_icon.svg",
  catIcon: "assets/images/category_icon.svg",
  fillHomeIcon: "assets/images/fill_home_icon.svg",
  fillCategoryIcon: "assets/images/fill_category_icon.svg",
  fillOrderIcon: "assets/images/fill_order_icon.svg",
  fillWishIcon: "assets/images/fill_wish_icon.svg",
  fillUserIcon: "assets/images/fill_user_icon.svg",
  notiIcon: "assets/images/noti_icon.svg",
  langIcon: "assets/images/lang_icon.svg",
  payIcon: "assets/images/lang_icon.svg",
  walletIcon: "assets/images/lang_icon.svg",
  phoneIcon: "assets/images/phone_icon.svg",
  termIcon: "assets/images/term_icon.svg",
  faqIcon: "assets/images/faq_icon.svg",
  aboutIcon: "assets/images/about_icon.svg",
  filterIcon: "assets/images/filter_icon.svg",
  cartIcon: "assets/images/cart.png",
  youtubeIcon: "assets/images/youtubeIcon.png",
  tiktokIcon: "assets/images/tik-tok.png"
};
